import { EventLogState } from './types';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import { AxiosResponse } from 'axios';
import moduleUtils from '../moduleUtils';
import { DefaultBackendEventLog } from '@/shared/backend/eventLog';
import { LogEntry, LogEntityType } from '@/shared/model/logEntry';
import { SearchParams } from '@/shared/model/searchParams';

const logger = new Logger('actions.eventLog');
export const actions: ActionTree<EventLogState, RootState> = {
  getEventLog(
    { commit, dispatch },
    payload: { entityType: LogEntityType; entityId: string }
  ) {
    commit('setEventLogIsLoading', true);
    return DefaultBackendEventLog.getEventLog(
      payload.entityType,
      payload.entityId
    )
      .then((response: AxiosResponse<LogEntry[]>) => {
        commit('setEventLogAllEntries', response.data);
        dispatch('updateCurrentPageEventLogEntries');
        return response.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setEventLogIsLoading', false);
      });
  },
  updateCurrentPageEventLogEntries({ getters, dispatch, commit }) {
    // Filtering
    dispatch('updateFilteredEventLogEntries');

    const searchParams = getters.getEventLogSearchParams as SearchParams;
    const filteredLogEntries = getters.getEventLogFilteredEntries as LogEntry[];
    let currentPageLogEntries = [...filteredLogEntries];

    // Sorting
    if (searchParams.dataOption.sortBy.length > 0) {
      const sortBy = searchParams.dataOption.sortBy[0];
      let sortDesc = searchParams.dataOption.sortDesc;
      if (Array.isArray(sortDesc)) {
        sortDesc = sortDesc[0] as boolean;
      }

      currentPageLogEntries = currentPageLogEntries.sort((a, b) => {
        if (sortBy == 'dateTime') {
          if (sortDesc) {
            return (
              new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
            );
          } else {
            return (
              new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
            );
          }
        } else if (sortBy == 'executedByName') {
          if (sortDesc) {
            return b.executedByName > a.executedByName ? -1 : 1;
          } else {
            return b.executedByName > a.executedByName ? 1 : -1;
          }
        }
        return 0;
      });
    }

    // Pagination
    const startIndex =
      (searchParams.dataOption.page - 1) * searchParams.dataOption.itemsPerPage;
    const endIndex = startIndex + searchParams.dataOption.itemsPerPage;
    currentPageLogEntries = currentPageLogEntries.slice(startIndex, endIndex);

    // Commit
    commit('setEventLogCurrentPageEntries', currentPageLogEntries);
  },
  updateFilteredEventLogEntries({ getters, commit }) {
    const searchParams = getters.getEventLogSearchParams as SearchParams;
    const allLogEntries = getters.getEventLogAllEntries as LogEntry[];

    var filteredLogEntries: LogEntry[];
    if (searchParams.dataOption.filter) {
      const searchText = searchParams.dataOption.filter.toLowerCase().trim();

      function searchFunction(x: LogEntry) {
        if (x.executedByName.toLowerCase().includes(searchText)) {
          return true;
        }

        return (
          x.displayText
            ?.map((x) => x.join('').toLowerCase())
            ?.some((x) => x.includes(searchText)) ?? false
        );
      }

      filteredLogEntries = allLogEntries.filter(searchFunction);
    } else {
      filteredLogEntries = [...allLogEntries];
    }

    commit('setEventLogFilteredEntries', filteredLogEntries);
  },
};
